import React, { useState, useRef } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { connect } from 'react-redux'
import LoanerInventoryForm from './LoanerInventoryForm'
import * as components from '../../components'
import SlidingPane from 'react-sliding-pane'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'

export const EditLoanerInventoryItem = ({
  title,
  onSubmit,
  loanerInventoryItem,
}) => {
  const formRef = useRef()
  const dispatch = useDispatch()
  const [isPaneOpen, setIsPaneOpen] = useState(false)

  const updateInventoryItems = (data) => {
    new rest.LoanerInventoryService(data.url)
      .makePutRequest(data)
      .then((response) => {
        onSubmit()
        dispatch(showSuccessToast('Success', 'Loaner items  Edited.'))
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }

  const LoanerInventoryFormFormWithData = connect((state) => ({
    initialValues: { ...loanerInventoryItem }, // pull initial values from account reducer
  }))(LoanerInventoryForm)
  return (
    <>
      <ReactBootstrap.Dropdown.Item
        variant="dark"
        size="sm"
        onClick={() => setIsPaneOpen(true)}
      >
        {components.ICONS.EDIT} Edit
      </ReactBootstrap.Dropdown.Item>
      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={title}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <LoanerInventoryFormFormWithData
          ref={formRef}
          onSubmit={updateInventoryItems}
          enableBulkMode={false}
        />
      </SlidingPane>
    </>
  )
}
